import FooterNavigation from './FooterNavigation';

export default FooterNavigation;
